import { render } from "./add-notifications.vue?vue&type=template&id=2b55d03e&scoped=true"
import script from "./add-notifications.vue?vue&type=script&lang=js"
export * from "./add-notifications.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./add-notifications.vue?vue&type=style&index=1&id=2b55d03e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b55d03e"]])

export default __exports__